import React from 'react';
import { isEmpty, map } from 'lodash';
import Globalizer from '../../../globalizer';
import common from '../../../common/common';
import translateService from '../../../common/translateService';
import Button from '../../Button.jsx';
import './ProductSummary.scss';

const ProductSummary = ({ data, handleModalStateChange, currencySymbol }) => {
    Globalizer.init();

    return data.isSuccess ? (
        data.isReassortment ? (
            <div className='prd-modal-cart-wrapper'>
                <div className='prd-modal-cart-heading'>
                    <p>
                        <svg height='20' width='30'>
                            <path
                                className='prd-modal-cart-check'
                                d='M4 9 L9 14 L19 4'
                            />
                        </svg>
                        {translateService.get(
                            `productDetail.cart.label.unavailable`
                        )}
                    </p>
                    <span
                        className='prd-modal-cart-button close'
                        onClick={handleModalStateChange}>
                        &times;
                    </span>
                </div>
                <div className='prd-modal-cart-container'>
                    <div className='prd-modal-cart-summary'>
                        <div className='prd-modal-cart-summary-img'>
                            <img
                                src={common.contentFromCdn({
                                    path: `${data.productImageUrl}`,
                                    keepUrlAsIs: false,
                                })}
                                alt={data.productTitle}
                            />
                        </div>
                        <div className='prd-modal-cart-summary-text'>
                            <h4 className='prd-modal-cart-summary-title'>
                                {data.productTitle}
                            </h4>
                            <div className='prd-modal-cart-summary-attributes'>
                                {map(data.productAttributes, (value, key) => {
                                    return (
                                        <p key={key}>
                                            {isEmpty(value) ? (
                                                <strong>{key}</strong>
                                            ) : (
                                                <>
                                                    <strong>{`${key}: `}</strong>
                                                    {value}
                                                </>
                                            )}
                                        </p>
                                    );
                                })}
                                <p>{`${translateService.get(
                                    `productDetail.quantity`
                                )}: ${data.productQuantityAdded}`}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='prd-modal-cart-footer'>
                    <Button
                        className='prd-modal-cart-button primary'
                        text={translateService.get(
                            `productDetail.cart.goToNotifications`
                        )}
                        onClick={() => {
                            window.location = data.url;
                        }}
                    />{' '}
                    {/* <a
                        href={data.url}
                        className='prd-modal-cart-button primary'>
                        {translateService.get(
                            `productDetail.cart.goToNotifications`
                        )}
                    </a> */}
                    <a
                        onClick={handleModalStateChange}
                        className='prd-modal-cart-button prd-link'>
                        {translateService.get(
                            `productDetail.cart.continueShopping`
                        )}
                    </a>
                </div>
            </div>
        ) : (
            <div className='prd-modal-cart-wrapper'>
                <div className='prd-modal-cart-heading'>
                    <p>
                        <svg height='20' width='30'>
                            <path
                                className='prd-modal-cart-check'
                                d='M4 9 L9 14 L19 4'
                            />
                        </svg>
                        {translateService.get(
                            `productDetail.cart.label.available`
                        )}
                    </p>
                    <span
                        className='prd-modal-cart-button close'
                        onClick={handleModalStateChange}>
                        &times;
                    </span>
                </div>
                <div className='prd-modal-cart-container'>
                    <div className='prd-modal-cart-summary'>
                        <div className='prd-modal-cart-summary-img'>
                            <img
                                src={common.contentFromCdn({
                                    path: `${data.productImageUrl}`,
                                    keepUrlAsIs: false,
                                })}
                                alt={data.productTitle}
                            />
                        </div>
                        <div className='prd-modal-cart-summary-text'>
                            <h4 className='prd-modal-cart-summary-title'>
                                {data.productTitle}
                            </h4>
                            <div className='prd-modal-cart-summary-price'>
                                <h4>
                                    {`${currencySymbol} ${Globalizer.formatNumber(
                                        data.productPriceDiscounted
                                    )}`}
                                </h4>
                                {data.productPriceDiscounted !==
                                    data.productPriceFull && (
                                    <h4 className='prd-modal-cart-summary-price-discount'>
                                        {`${currencySymbol} ${Globalizer.formatNumber(
                                            data.productPriceFull
                                        )}`}
                                    </h4>
                                )}
                            </div>
                            <div className='prd-modal-cart-summary-attributes'>
                                {map(data.productAttributes, (value, key) => {
                                    return (
                                        <p key={key}>
                                            {isEmpty(value) ? (
                                                <strong>{key}</strong>
                                            ) : (
                                                <>
                                                    <strong>{`${key}: `}</strong>
                                                    {value}
                                                </>
                                            )}
                                        </p>
                                    );
                                })}
                                <p>{`Qty: ${data.productQuantityAdded}`}</p>
                            </div>
                        </div>
                    </div>
                    <div className='prd-modal-cart-cartSummary'>
                        <p>
                            {`${translateService.get(
                                `productDetail.cart.itemsInCart`
                            )}: ${data.cartTotalItems}`}
                        </p>
                    </div>
                </div>
                <div className='prd-modal-cart-footer'>
                    <Button
                        className='prd-modal-cart-button primary'
                        text={translateService.get(
                            `productDetail.cart.goToCart`
                        )}
                        onClick={() => {
                            window.location = data.url;
                        }}
                    />
                    {/* <a
                        href={data.url}
                        className='prd-modal-cart-button primary'>
                        {translateService.get(`productDetail.cart.goToCart`)}
                    </a> */}
                    <a
                        onClick={handleModalStateChange}
                        className='prd-modal-cart-button prd-link'>
                        {translateService.get(
                            `productDetail.cart.continueShopping`
                        )}
                    </a>
                </div>
            </div>
        )
    ) : (
        <div className='prd-modal-cart-wrapper'>
            <div className='prd-modal-cart-heading'>
                <p>
                    <svg height='20' width='30'>
                        <path
                            className='prd-modal-cart-error'
                            d='M2 2 L15 15'
                        />
                        <path
                            className='prd-modal-cart-error'
                            d='M2 15 L15 2'
                        />
                    </svg>
                    {translateService.get(`productDetail.genericError`)}
                </p>
                <span
                    className='prd-modal-cart-button close'
                    onClick={handleModalStateChange}>
                    &times;
                </span>
            </div>
            <div className='prd-modal-cart-container'>
                <p>{data.message}</p>
            </div>
            <div className='prd-modal-cart-footer'>
                <a
                    onClick={handleModalStateChange}
                    className='prd-modal-cart-button prd-link'>
                    {translateService.get(
                        `productDetail.cart.continueShopping`
                    )}
                </a>
            </div>
        </div>
    );
};

export default ProductSummary;
